<!--
 * @Version: 1.2
 * @Author: admin
 * @Description: components
 * @Date: 2022-06-23 14:44:40
 * @LastEditors: sky
 * @LastEditTime: 2022-09-15 17:27:23
-->
<template>
  <a-breadcrumb class="container-breadcrumb">
    <a-breadcrumb-item @click="goHome" style="cursor: pointer">
      <icon-apps />
    </a-breadcrumb-item>
    <a-breadcrumb-item v-for="item in items" :key="item">
      {{ item }}
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script lang="ts" setup>
  import { PropType } from "vue";
  import { useRouter } from "vue-router";
  const router = useRouter();
  defineProps({
    items: {
      type: Array as PropType<string[]>,
      default() {
        return [];
      },
    },
  });
  const goTo = (data) => {
    router.push({ name: data.name });
  };
  const goHome = () => {
    router.push({ name: "home" });
  };
</script>

<style scoped lang="less">
  .container-breadcrumb {
    margin: 16px 0;
    :deep(.arco-breadcrumb-item) {
      color: rgb(var(--gray-6));
      &:last-child {
        color: rgb(var(--gray-8));
      }
    }
  }
</style>
